<script setup>
import { ElCarousel, ElCarouselItem } from 'element-plus';

</script>
<template>
  <div class="w-full rounded-lg min-h-[500px] flex">
    <ElCarousel class="w-full h-full flex-1" height="100%">
      <ElCarouselItem v-for="item in 1" :key="item">
        <div class="w-full flex justify-center items-center h-full">
          <img src="https://lms-v3.s3.us-east-1.amazonaws.com/image+(85).png" class="w-full h-full object-center" />
        </div>
      </ElCarouselItem>
    </ElCarousel>
  </div>
</template>

<style lang="scss" scoped></style>
